module.exports = __webpack_public_path__ + "static/img/map.599fc36.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hrdonates/map.png
// module id = zP3D
// module chunks = 0